module.exports = __webpack_public_path__ + "static/media/enjoy_freedom.b0b96df8.svg";